import React, {useContext} from "react";
import PropTypes from 'prop-types';
import MenuDesignerContext from "../../../../ContextComponents/MenuDesignerContext";
import ComponentSettings from "../../../ApplicationBuilder/ApplicationDesigner/Designers/ScreenDesigner/ToolBar/Panels/ComponentSettings";
import {ScreenDesignerContextNew} from "../../../../ContextComponents/ScreenDesignerContextNew";

const Properties = () => {
    const {
        selectedItem: {item = {}, path, isDisabled},
        onChangeMenuItemProps,
        createEvent,
        removeEvent,
        saveAction,
        values
    } = useContext(MenuDesignerContext);

    return (
        <>
            <ScreenDesignerContextNew.Provider value={{
                screenValues: {
                    ...values.main,
                    otherComponents: []
                },
                currentCustomResolution: 'desktop',
                listStorage: [],
                openListDesigner: {open: false},
                selectedComponent: {
                    path,
                    component: {
                        type: 'menuItem',
                        _isLocked: isDisabled,
                        ...item
                    }
                },
                onChangeDefaultFields: onChangeMenuItemProps,
                createEvent,
                removeEvent: (index) => removeEvent(path, index),
                onChangeEventComponent: (v, p) => saveAction(v, 'events'+'.'+p),
                actionSave: (actionIndex, actions) => saveAction(actions, `events.${actionIndex}.actions`)
            }}>
                <ComponentSettings/>
            </ScreenDesignerContextNew.Provider>
        </>
    )
};
export default Properties

PropTypes.propTypes = {
    selectedItem: PropTypes.object,
    saveAction: PropTypes.func,
    setValue: PropTypes.func
};